import Header from "../Components/Header/Header";
import { Link } from 'react-router-dom';
import { useAuthContext } from "../context/AuthContext";
// import Loading from "../Components/Hooks/Loading";
import user_icon from "../Media/person.svg";
import get_help from "../Media/get-help.svg";
import quick_cope from "../Media/pause.svg";
import practice_skills from "../Media/practice.svg";
import chain_analysis from "../Media/analyze.svg";

import "./ChooseOption.css";
import Footer from "../Components/Footer/Footer";
// import { useContext, useEffect } from "react";
// import apiContext from "../context/API/apiContext";
// import { useState } from "react";
// import { Elements } from "@stripe/react-stripe-js";

const ChooseOption = () =>{

    const { user, isLoading } = useAuthContext();
    let userName;
    if(user !=undefined)
    userName = user.firstName?user.firstName:user.username;
    
    console.log(user);
   
        return(
            <div className="main-option">
                <div className="container">
                    <Header title="Cope Ahead" type="Primary"/>
                    <div className="content-wrap bg-gradient-light">
                        <div className="option-box-wrap">
                            <div className="option-wrap-inner">
                                {/* <div className="logo-wrap">
                                    <span><img src={Logo} alt="logo"/></span>    
                                    <span>Cope Ahead</span>                       
                                </div> */}
                                <div className="greeting">
                                    <div className="user-informations">
                                        <p className="sub-title-text">Glad you’re here,</p>
                                        <div className="user--name">{userName}!</div>
                                    </div>
                                    <div className="user-img fade-in-up"> 
                                        <Link to="/Settings" className="hover-zoom"><img src={user_icon} alt="user-image"/></Link>
                                    </div>
                                </div>
                                
                                {/* <div className="option-box bg-white fade-in-up delay-1 top-box mt---20">
                                    <p className="text-color">YOUR CURRENT STREAK</p>
                                    <h4 className="sub-title-heading ctr mb---30 blue">
                                        <img src="https://copeaheadbucket-dev.s3.us-east-1.amazonaws.com/o0_28bf9d9fe7.svg" alt="quick-cope"/> 6 Days</h4>
                                    <div className="days-dots">
                                        <div className="ddot"><div className="dot active"></div>Mon</div>
                                        <div className="ddot"><div className="dot active"></div>Tue</div>
                                        <div className="ddot"><div className="dot active"></div>Wed</div>
                                        <div className="ddot"><div className="dot active"></div>Thu</div>
                                        <div className="ddot"><div className="dot active"></div>Fry</div>
                                        <div className="ddot"><div className="dot active"></div>Sat</div>
                                        <div className="ddot"><div className="dot"></div>Sun</div>
                                    </div>
                                </div> */}
                                <div className="option-box-inner">
                                <h4 className="sub-title-heading ctr mb---20 blue">Let’s dive in.</h4>
                                <div className="boxes">
                                    <div className="option-box bg-white fade-in-up hover-zoom">
                                        <Link to="/QuickCope">
                                            <img src={quick_cope} alt="quick-cope"/>
                                            <h5 className="blue">Quick Cope</h5>
                                            <p className="text-color">Help me calm down</p>
                                        </Link>
                                    </div>
                                    <div className="option-box bg-white fade-in-up hover-zoom">
                                        <Link to="/Activities">
                                            <img src={practice_skills} alt="practice-skills"/>
                                            <h5 className="blue">Practice</h5>
                                            <p className="text-color">I’d like to learn</p>
                                        </Link>
                                    </div>
                                    <div className="option-box bg-white fade-in-up hover-zoom">
                                        <Link to="/chain-analysis">
                                            <img src={chain_analysis} alt="chain-analysis"/>
                                            <h5 className="blue">Analyze</h5>
                                            <p className="text-color">I want to understand</p>
                                        </Link>
                                    </div>
                                    <div className="option-box bg-white fade-in-up hover-zoom">
                                        <Link to="pages/sos">
                                            <img src={get_help} alt="sos"/>
                                            <h5 className="blue">SOS</h5>
                                            <p className="text-color">I need help now</p>
                                        </Link>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    
}
export default ChooseOption;